import styled from 'styled-components';

export const Wrapper = styled.div`
    position: relative;
	padding: 32px;
	box-sizing: border-box;
	z-index: 999;
`;